import { render, staticRenderFns } from "./senders-filter.vue?vue&type=template&id=44b3c67f&"
import script from "./senders-filter.vue?vue&type=script&lang=js&"
export * from "./senders-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports